export default "__VITE_ASSET__Bto5i5Km__"